/**
 * Register plugins for IP
 * @module
 */

module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/ip'));
  PluginManager.registerAudienceMatcher('ip', require('./matchers/ip'));
};
